import { refreshToken } from './refresh-token.js'
import { revokeToken } from './revoke-token.js'

let listenersAdded = false
export function addListeners (containerElement, tokenSetInfo, callbacks) {
  if (listenersAdded) return
  listenersAdded = true

  console.log('addListeners token info', containerElement)
  containerElement.addEventListener('click', async (clickEvent) => {
    console.log('clickEvent', clickEvent)
    const buttonElement = clickEvent.target.closest('button')
    console.log('buttonElement', buttonElement)
    if (!buttonElement) return

    buttonElement.classList.add('is-loading')

    const buttonAction = buttonElement.getAttribute('data-action')
    console.log('buttonAction', buttonAction)
    if (!buttonAction) return

    await handleButtonAction(buttonAction, tokenSetInfo, callbacks)

    buttonElement.classList.remove('is-loading')
  })
}

async function handleButtonAction (buttonAction, tokenSetInfo, callbacks = {}) {
  console.log('handleButtonAction', buttonAction, tokenSetInfo)
  if (buttonAction === 'refresh-token') {
    await refreshToken(tokenSetInfo)
    await callbacks.onTokenUpdated?.()
  }

  if (buttonAction === 'revoke-token') {
    await revokeToken(tokenSetInfo)
    await callbacks.onTokenUpdated?.()
  }
}
